import { render, staticRenderFns } from "./RevenueChart.vue?vue&type=template&id=45ff06a6&scoped=true&"
import script from "./RevenueChart.vue?vue&type=script&lang=js&"
export * from "./RevenueChart.vue?vue&type=script&lang=js&"
import style0 from "./RevenueChart.vue?vue&type=style&index=0&id=45ff06a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff06a6",
  null
  
)

component.options.__file = "RevenueChart.vue"
export default component.exports